import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  VERSION,
} from "@angular/core";
import { LmsService } from "../_Lms/services/lms.service";
import { LosService } from "../_LOS/services/los.service";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { MasterService } from "../Shared/app.Masters.Service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
declare var $: any;

@Component({
  selector: "app-camspay",
  templateUrl: "./camspay.component.html",
  styleUrls: ["./camspay.component.scss"],
})
export class camspayComponent implements OnInit {
  

  constructor(
    private snackBar: MatSnackBar,
    private losService: LosService,
    private lmsService: LmsService,
    private _commonfunctions: CommonFunctions,
    private MasterService: MasterService,
    private route: ActivatedRoute
  ) {
   
    // this.route.paramMap.subscribe((param: ParamMap) => {
    //   var output = param.get("output"); // encdec.decrypt(param.get("id"));
    //   console.log("output",output);
    // });
  }
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  ngOnInit(): void {
   
    const param = this.route.snapshot.queryParamMap.get('output');
    console.log(param);
    this.MasterService.DecryptAES({cipherText:param.split('.')[1],iv:param.split('.')[0]}).subscribe((res: any) => {
      console.log(res);
      if(res!=null){
        let jsonObject = JSON.parse(res);
        //let req=JSON.parse(jsonObject.req);
         var NACH = {
            RefNo: jsonObject.trxn_no,
              URL: "Registration",
              Request: window.location.href,
              Response: res,
              CreatedBy: 0,
              Status: jsonObject.status,
              Identifier: jsonObject.mandate_ref_no,
              UMRNNumber:jsonObject.umn,
              NachAmount:jsonObject.enach_amount,
              Frequency:jsonObject.req.frequencydeduction,
              debittype:jsonObject.req.debittype,
              Type:'CAMSPay'
            };
        
            let _data = {
              NACH: NACH,
            };
        
            //console.log('_data', _data);
            this.lmsService
              .LMS_Save_CAMSPayENach_Request_Response({ JSON: JSON.stringify(_data) })
              .subscribe((res1: any) => {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: jsonObject.status,
                  ...this.configSuccess,
                });
                
              });
      }
    });
    
  }
  
}
